import http from "@/axios";
import {CardInfo, CardState, CardType, EvolutionInfo} from './types';
import PlayerStore from "@/store/player";
import {WarriorClass} from "@/store/level/types";

export default class CardStore {

    public static fetchCardsInfo(): Promise<CardInfo[]> {
        return http.get('/api/card/info')
            .then(r => r.data)
            .then(contentObj => {
                const res: CardInfo[] = [];
                let activeCardType: CardType | null = null;
                for (const obj of contentObj) {
                    let card = Object.assign(new CardInfo(), obj);
                    res.push(card);
                    if (card.active) {
                        activeCardType = card.cardType;
                    }
                }
                PlayerStore.SET_CARD_STATE({ activeCard: activeCardType });
                return res;
            });
    }


    public static useCard(cardType: CardType): Promise<CardState> {
        return http.get('/api/card/use?cardType=' + cardType.toString())
            .then(r => r.data)
            .then(cardState => {
                let cs = Object.assign(new CardState(), cardState);
                PlayerStore.SET_CARD_STATE(cs);
                return cs;
            });
    };

    public static fetchEvolutionInfo(): Promise<EvolutionInfo> {
        return http.get("/api/evolution/available-forces")
            .then(r => r.data);
    }

    public static async checkEvolutionAvailability(creatureId: number, selectedForceClass: WarriorClass, targetClass: WarriorClass): Promise<boolean | string> {
        try {
            const response = await http.post('/api/evolution/check', null, {
                params: { creatureId, selectedForceClass, targetClass }
            });

            if (response.data === false) {
                return false;
            }
            return true;

        } catch (error) {
            console.log(error);
            return false;
        }
    }

    public static async evolve(creatureId: number, selectedForceClass: WarriorClass, targetClass: WarriorClass): Promise<boolean> {
        try {
            const response = await http.post("/api/evolution/evolve", null, {
                params: {
                    creatureId: creatureId,
                    selectedForceClass: selectedForceClass,
                    targetClass: targetClass
                }
            });
            if (response.data?.player) {
                PlayerStore.SET_PLAYER(response.data.player);
            }
            PlayerStore.SET_CARD_STATE({activeCard: null});
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    }


    public static fetchEvolutionOptionsByCreature(creatureId: number, selectedForce: WarriorClass): Promise<EvolutionInfo> {
        return http.get("/api/evolution/available-forces/by-creature", {
            params: { creatureId, selectedForce }
        }).then(r => r.data as EvolutionInfo);
    }

    public static cancelActiveCard(): Promise<void> {
        return http.post("/api/card/cancel")
            .then(() => {
                PlayerStore.SET_CARD_STATE({ activeCard: null });
            });
    }
}


